import * as Yup from 'yup'
import { Form, InputGroup, Row, Col } from 'react-bootstrap'
import { getColumnString } from '../../common'

type Values = {
  columns: number
  orientation: string
  marginRows: number
}

type EnumValues = {
  headingOrientations: Record<string, string>
}

type Props = {
  values: Values
  errors: Partial<Record<keyof Values, string>>
  touched: Partial<Record<keyof Values, boolean>>
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleBlur: React.FocusEventHandler<HTMLElement>
  handleSubmit: (values: Values) => void
  enumValues: EnumValues
  isSettingWritable: boolean
  rowIndex: number
}

const _FigureRowMarginSettingForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  enumValues,
  isSettingWritable,
  rowIndex
}: Props) => {
  const columnString = getColumnString(String(values.columns))
  const orientationString = enumValues.headingOrientations[values.orientation]
  const combinedColumnString = `${columnString}${orientationString}写真`
  return (
    <Row sm='auto' className={`row-${rowIndex + 1}`}>
      <Col sm={1}>{combinedColumnString}</Col>
      <Col>
        <InputGroup size='sm' hasValidation>
          <Form.Control
            id='marginRowsInput'
            type='number'
            name='marginRows'
            value={values.marginRows || ''}
            onChange={(e) => {
              handleChange(e)
              handleSubmit(values)
            }}
            onBlur={handleBlur}
            isInvalid={!!(touched.marginRows && errors.marginRows)}
            disabled={!isSettingWritable}
          />
          <InputGroup.Text>行取り</InputGroup.Text>
          <Form.Control.Feedback type='invalid'>{errors.marginRows}</Form.Control.Feedback>
        </InputGroup>
      </Col>
    </Row>
  )
}

export const FigureRowMarginSettingForm = Object.assign(_FigureRowMarginSettingForm, {
  schema: Yup.object().shape({
    marginRows: Yup.number().min(1).required()
  })
})
